import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { resources, SUPPORTED_LANGUAGES, AppLanguage } from './locale-resources';

const STORAGE_KEY = 'urace-language';

const isSupported = (lng: string | null | undefined): lng is AppLanguage =>
  !!lng && (SUPPORTED_LANGUAGES as readonly string[]).includes(lng);

// Saved choice wins; otherwise Vietnamese browsers get Vietnamese, everyone else English.
const readInitialLanguage = (): AppLanguage => {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (isSupported(saved)) return saved;
  } catch {
    // Storage blocked (private mode); fall through to the browser language.
  }
  const browser = (navigator.languages?.[0] || navigator.language || '').toLowerCase();
  return browser.startsWith('vi') ? 'vi' : 'en';
};

i18n.use(initReactI18next).init({
  resources,
  lng: readInitialLanguage(),
  fallbackLng: 'en',
  defaultNS: 'common',
  returnNull: false,
  // React already escapes rendered strings.
  interpolation: { escapeValue: false },
});

const syncDocumentLanguage = (lng: string) => {
  document.documentElement.setAttribute('lang', lng);
};
syncDocumentLanguage(i18n.language);

i18n.on('languageChanged', lng => {
  syncDocumentLanguage(lng);
  try {
    localStorage.setItem(STORAGE_KEY, lng);
  } catch {
    // Non-fatal: the language just won't persist.
  }
});

export default i18n;
